<template>
    <Navbar/>
    <UserAgreeBody/>
    <Footer/>
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import Navbar from "@/components/NavbarBody.vue";
  import UserAgreeBody from "@/components/UserAgreeBody.vue";
  import Footer from "@/components/FooterBody.vue"; 
  
  export default defineComponent({
    name: "UserAgreeView",
    components: {
      Navbar,
      UserAgreeBody,
      Footer
    },
  });
  </script>
  